import createSagaMiddleware             from 'redux-saga';
import { applyMiddleware }              from 'redux';

const sagaMiddleware        = createSagaMiddleware();

// Tüm middleware'lar middleware/index.js'in içerisinde toplanıyor.
export default {
    store: applyMiddleware(
        sagaMiddleware
    ),
    saga: sagaMiddleware
};